module.exports = __webpack_public_path__ + "static/media/pause.92cf237d.svg";